module.exports = __webpack_public_path__ + "img/qr3.c27e3c71.png";